/**
 * Created by mike on 6/14/2016.
 */

jQuery(document).ready(function() {

    //Fix the 'must click twice on touch enabled devices'
    jQuery('.has-dropdown > a, .is-dropdown-submenu-parent > a').on('click touchend', function(e) {
        var el = jQuery(this);
        var link = el.attr('href');
        window.location = link;
    });



// Hide and show the logo on scroll
// jQuery(window).scroll(function() {
//     if (jQuery(window).scrollTop() > 2000) {
//         jQuery('.logo').hide();
//         jQuery('.tagline').hide();
//     } else {
//         jQuery('.logo').show();
//         jQuery('.tagline').show();
//     }
// });
//     jQuery(window).load(function delay() {
//     jQuery(".menu-kit-menu-mk4-container").toggle();
//     var boxHeight = jQuery(".menu-kit-menu-mk4-container").height();
//     jQuery(".menu-kit-menu-mk4-container").height(boxHeight);
//     jQuery(alert(boxHeight));
// })
// setTimeout(delay, 10000);

// Wrap the submenus with the necessary container attributes to make them sticky
// jQuery('#custom-menu-row').attr({
//     'data-sticky':'',
//     'data-anchor':'stick-here',
//     'data-margin-top':2
// });
jQuery('#custom-menu-row').attr('data-sticky-container','');

});

jQuery('.footer #menu-footer-menu > li').each(function(){
    var subMenuCont = jQuery(this).find('ul.sub-menu');
    jQuery(this).children('.menu-image-title-after').addClass('menu-title');
    jQuery(this).children('.menu-image-title-after').prependTo(subMenuCont);
});